import { GlobalReviewSummary, Product, Variant } from '@castlery/modules-product-domain';

export const generateKeyWords = (product: Product, variant: Variant) => {
  const keywordsArr = [];

  // 产品名称和选项
  const optionWords = variant?.variant_option_values?.map((v: any) => v.presentation).join(', ') || '';
  keywordsArr.push(`${product.name}${optionWords ? `, ${optionWords}` : ''}`);

  // 分类
  const categoryWords = product.taxons
    ?.filter((t: any) => t.level !== 0)
    .map((t: any) => t.name)
    .join(', ');

  if (categoryWords) {
    keywordsArr.push(categoryWords);
  }

  return keywordsArr.filter((w) => w !== '').join(', ');
};

export const generateRatingString = (product: Product) => {
  const reviews = product.reviews;
  if ('total_count' in reviews && 'average_rating' in reviews) {
    if (reviews.total_count < 1 || reviews.average_rating < 3) {
      return '';
    }

    const rating = {
      '@type': 'AggregateRating',
      ratingValue: reviews.average_rating,
      reviewCount: reviews.total_count,
      worstRating: '1',
      bestRating: '5',
    };

    return `"aggregateRating": ${JSON.stringify(rating)},`;
  }
  return '';
};

export const generateThreeReviews = (product: Product) => {
  const reviews = product.reviews as any;
  if ('average_rating' in reviews && 'reviews' in reviews) {
    const productReviews = reviews?.reviews;
    if (!productReviews || productReviews?.length === 0 || reviews?.average_rating < 3) {
      return '';
    }

    const result = productReviews?.map((review: any) => ({
      '@type': 'Review',
      author: {
        '@type': 'Person',
        name: (!!review && review.user_name?.trim()) || 'Castlery Customer',
      },
      datePublished: review.updated_at,
      reviewBody: review.content,
      reviewRating: {
        '@type': 'Rating',
        bestRating: '5',
        ratingValue: review.rating,
        worstRating: '1',
      },
    }));

    return `"review": ${JSON.stringify(result)},`;
  }
  return '';
};
